module.exports = __webpack_public_path__ + "media/images/v2/zoom_logo-88d7cffc34f3b56b388fa2c10ca80014.png";